// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.internship-container {
  font-family: 'Comic Neue', 'Nunito', sans-serif;
  color: #2d3748;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Hero Section */
.hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #f0fff4 0%, #ebf8ff 100%);
  border-radius: 20px;
  padding: 40px;
  margin-bottom: 40px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.hero-content h1 {
  font-size: 3rem;
  color: #2b6cb0;
  margin-bottom: 10px;
}

.hero-content h1 span {
  color: #2c5282;
}

.tagline {
  font-size: 1.5rem;
  color: #4a5568;
  margin-bottom: 20px;
}

.focus-areas {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.focus-bubble {
  background-color: #4299e1;
  color: white;
  padding: 8px 15px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
}

.cta-button {
  /* background-color: #a0aec0;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.7;
  pointer-events: none; */
  background-color: #2b6cb0;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(43, 108, 176, 0.3);
}

.registration-status {
  display: block; /* Ensures it appears on its own line */
  text-align: left; /* Centers the text */
  margin-top: 4px;
  margin-bottom: 12px; /* Adds space below the text (before the button) */
  color: #6B7280; /* Subtle gray color */
  font-size: 1rem; /* Slightly smaller than standard text */
  font-style: italic; /* Optional: for a subdued appearance */
  font-weight: bold;
}

.cta-button:hover {
  background-color: #2c5282;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(43, 108, 176, 0.4);
}

.hero-image img {
  max-width: 400px;
  height: auto;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

/* Highlights Section */
.highlights-section {
  margin: 60px 0;
  text-align: center;
}

.highlights-section h2 {
  color: #2b6cb0;
  font-size: 2.2rem;
  margin-bottom: 40px;
}

.highlights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 25px;
}

.highlight-card {
  background: white;
  border-radius: 15px;
  padding: 25px 20px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s;
  border: 1px solid #e2e8f0;
}

.highlight-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.highlight-icon {
  font-size: 2.5rem;
  color: #4299e1;
  margin-bottom: 15px;
}

.highlight-card h3 {
  color: #2b6cb0;
  margin-bottom: 10px;
}

/* Program Details */
.details-section {
  display: flex;
  gap: 30px;
  margin: 60px 0;
}

.details-card {
  flex: 1 1;
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  border: 1px solid #e2e8f0;
}

.age-duration {
  text-align: center;
  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);
}

.big-text {
  font-size: 2rem;
  font-weight: bold;
  color: #2b6cb0;
  margin: 10px 0 30px;
}

.format ul {
  list-style-type: none;
  padding: 0;
}

.format li {
  padding: 10px 0;
  font-size: 1.1rem;
  position: relative;
  padding-left: 30px;
}

.format li:before {
  content: "✓";
  color: #4299e1;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* Testimonials */
.testimonials-section {
  margin: 60px 0;
  text-align: center;
}

.testimonials-section h2 {
  color: #2b6cb0;
  font-size: 2.2rem;
  margin-bottom: 40px;
}

.testimonials-container {
  display: flex;
  gap: 30px;
  justify-content: center;
}

.testimonial-card {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  max-width: 400px;
  position: relative;
  border: 1px solid #e2e8f0;
}

.testimonial-card:before {
  /* content: """; */
  font-size: 5rem;
  color: #bee3f8;
  position: absolute;
  top: 10px;
  left: 20px;
  line-height: 1;
  opacity: 0.3;
}

.testimonial-content {
  font-size: 1.1rem;
  font-style: italic;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.testimonial-author {
  font-weight: bold;
  color: #4299e1;
}

/* FAQ Section */
.faq-section {
  margin: 60px 0;
}

.faq-section h2 {
  color: #2b6cb0;
  font-size: 2.2rem;
  margin-bottom: 40px;
  text-align: center;
}

.accordion {
  max-width: 800px;
  margin: 0 auto;
}

.accordion-item {
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
}

.accordion-question {
  width: 100%;
  text-align: left;
  padding: 20px;
  background: #4299e1;
  color: white;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
}

.accordion-question:hover {
  background: #2b6cb0;
}

.accordion-answer {
  padding: 20px;
  background: white;
  display: block;
}

/* Final CTA */
.final-cta {
  text-align: center;
  margin: 80px 0 40px;
  padding: 40px;
  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.final-cta h2 {
  color: #2b6cb0;
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.final-cta p {
  font-size: 1.2rem;
  margin-bottom: 30px;
  color: #4a5568;
}

/* Program Intro Text */
.program-intro {
  background-color: #f8fafc;
  border-left: 4px solid #4299e1;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 0 8px 8px 0;
}

.program-intro p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a5568;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
  }
  
  .focus-areas {
    justify-content: center;
  }
  
  .hero-image img {
    max-width: 300px;
    margin-top: 30px;
  }
  
  .details-section {
    flex-direction: column;
  }
  
  .testimonials-container {
    flex-direction: column;
    align-items: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/MyComponents/Internship/Internship.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,+CAA+C;EAC/C,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;;;;;;;;;;yBAUuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,cAAc,EAAE,uCAAuC;EACvD,gBAAgB,EAAE,qBAAqB;EACvC,eAAe;EACf,mBAAmB,EAAE,kDAAkD;EACvE,cAAc,EAAE,sBAAsB;EACtC,eAAe,EAAE,wCAAwC;EACzD,kBAAkB,EAAE,uCAAuC;EAC3D,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,4BAA4B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* Base Styles */\n.internship-container {\n  font-family: 'Comic Neue', 'Nunito', sans-serif;\n  color: #2d3748;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Hero Section */\n.hero-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #f0fff4 0%, #ebf8ff 100%);\n  border-radius: 20px;\n  padding: 40px;\n  margin-bottom: 40px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.hero-content h1 {\n  font-size: 3rem;\n  color: #2b6cb0;\n  margin-bottom: 10px;\n}\n\n.hero-content h1 span {\n  color: #2c5282;\n}\n\n.tagline {\n  font-size: 1.5rem;\n  color: #4a5568;\n  margin-bottom: 20px;\n}\n\n.focus-areas {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.focus-bubble {\n  background-color: #4299e1;\n  color: white;\n  padding: 8px 15px;\n  border-radius: 20px;\n  font-weight: bold;\n  font-size: 0.9rem;\n}\n\n.cta-button {\n  /* background-color: #a0aec0;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 30px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.7;\n  pointer-events: none; */\n  background-color: #2b6cb0;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 30px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 8px rgba(43, 108, 176, 0.3);\n}\n\n.registration-status {\n  display: block; /* Ensures it appears on its own line */\n  text-align: left; /* Centers the text */\n  margin-top: 4px;\n  margin-bottom: 12px; /* Adds space below the text (before the button) */\n  color: #6B7280; /* Subtle gray color */\n  font-size: 1rem; /* Slightly smaller than standard text */\n  font-style: italic; /* Optional: for a subdued appearance */\n  font-weight: bold;\n}\n\n.cta-button:hover {\n  background-color: #2c5282;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(43, 108, 176, 0.4);\n}\n\n.hero-image img {\n  max-width: 400px;\n  height: auto;\n  animation: float 6s ease-in-out infinite;\n}\n\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n  100% { transform: translateY(0px); }\n}\n\n/* Highlights Section */\n.highlights-section {\n  margin: 60px 0;\n  text-align: center;\n}\n\n.highlights-section h2 {\n  color: #2b6cb0;\n  font-size: 2.2rem;\n  margin-bottom: 40px;\n}\n\n.highlights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 25px;\n}\n\n.highlight-card {\n  background: white;\n  border-radius: 15px;\n  padding: 25px 20px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.05);\n  transition: all 0.3s;\n  border: 1px solid #e2e8f0;\n}\n\n.highlight-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 30px rgba(0,0,0,0.1);\n}\n\n.highlight-icon {\n  font-size: 2.5rem;\n  color: #4299e1;\n  margin-bottom: 15px;\n}\n\n.highlight-card h3 {\n  color: #2b6cb0;\n  margin-bottom: 10px;\n}\n\n/* Program Details */\n.details-section {\n  display: flex;\n  gap: 30px;\n  margin: 60px 0;\n}\n\n.details-card {\n  flex: 1;\n  background: white;\n  border-radius: 15px;\n  padding: 30px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.05);\n  border: 1px solid #e2e8f0;\n}\n\n.age-duration {\n  text-align: center;\n  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);\n}\n\n.big-text {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #2b6cb0;\n  margin: 10px 0 30px;\n}\n\n.format ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.format li {\n  padding: 10px 0;\n  font-size: 1.1rem;\n  position: relative;\n  padding-left: 30px;\n}\n\n.format li:before {\n  content: \"✓\";\n  color: #4299e1;\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n}\n\n/* Testimonials */\n.testimonials-section {\n  margin: 60px 0;\n  text-align: center;\n}\n\n.testimonials-section h2 {\n  color: #2b6cb0;\n  font-size: 2.2rem;\n  margin-bottom: 40px;\n}\n\n.testimonials-container {\n  display: flex;\n  gap: 30px;\n  justify-content: center;\n}\n\n.testimonial-card {\n  background: white;\n  border-radius: 15px;\n  padding: 30px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.05);\n  max-width: 400px;\n  position: relative;\n  border: 1px solid #e2e8f0;\n}\n\n.testimonial-card:before {\n  /* content: \"\"\"; */\n  font-size: 5rem;\n  color: #bee3f8;\n  position: absolute;\n  top: 10px;\n  left: 20px;\n  line-height: 1;\n  opacity: 0.3;\n}\n\n.testimonial-content {\n  font-size: 1.1rem;\n  font-style: italic;\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.testimonial-author {\n  font-weight: bold;\n  color: #4299e1;\n}\n\n/* FAQ Section */\n.faq-section {\n  margin: 60px 0;\n}\n\n.faq-section h2 {\n  color: #2b6cb0;\n  font-size: 2.2rem;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.accordion {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.accordion-item {\n  margin-bottom: 15px;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.accordion-question {\n  width: 100%;\n  text-align: left;\n  padding: 20px;\n  background: #4299e1;\n  color: white;\n  border: none;\n  font-size: 1.1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.accordion-question:hover {\n  background: #2b6cb0;\n}\n\n.accordion-answer {\n  padding: 20px;\n  background: white;\n  display: block;\n}\n\n/* Final CTA */\n.final-cta {\n  text-align: center;\n  margin: 80px 0 40px;\n  padding: 40px;\n  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.final-cta h2 {\n  color: #2b6cb0;\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n}\n\n.final-cta p {\n  font-size: 1.2rem;\n  margin-bottom: 30px;\n  color: #4a5568;\n}\n\n/* Program Intro Text */\n.program-intro {\n  background-color: #f8fafc;\n  border-left: 4px solid #4299e1;\n  padding: 20px;\n  margin-bottom: 30px;\n  border-radius: 0 8px 8px 0;\n}\n\n.program-intro p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #4a5568;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-section {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .focus-areas {\n    justify-content: center;\n  }\n  \n  .hero-image img {\n    max-width: 300px;\n    margin-top: 30px;\n  }\n  \n  .details-section {\n    flex-direction: column;\n  }\n  \n  .testimonials-container {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
